import { HistoricalNav } from "../types";
import { formatAsPercentage } from "../utils/currency";

export const AMC = [
  { name: "360 ONE Asset Management Limited" },
  { name: "Aditya Birla Sun Life AMC Ltd" },
  { name: "Angel One Asset Management Company Limited" },
  { name: "Axis Asset Management Company Limited" },
  { name: "Bajaj Finserv Asset Management Limited" },
  { name: "Bandhan Asset Management Company Limited" },
  { name: "Bank of India Investment Managers Private Limited" },
  { name: "Baroda BNP Paribas Asset Management India Pvt. Ltd." },
  { name: "Canara Robeco Asset Management Co. Ltd." },
  { name: "DSP Asset Managers Private Limited" },
  { name: "Edelweiss Asset Management Limited" },
  { name: "Franklin Templeton Asst Mgmt(IND)Pvt Ltd" },
  { name: "Groww Asset Management Ltd." },
  { name: "HDFC Asset Management Co Ltd" },
  { name: "HDFC Life Insurance Co Ltd" },
  { name: "Helios Capital Asset Management (India) Private Limited" },
  { name: "HSBC Asset Management (India) Private Ltd" },
  { name: "ICICI Prudential Asset Management Company Limited" },
  { name: "ICICI Prudential Life Insurance Co Ltd" },
  { name: "Invesco Asset Management (India) Private Ltd" },
  { name: "ITI Asset Management Limited" },
  { name: "JM Financial Asset Management Limited" },
  { name: "Kotak Mahindra Asset Management Co Ltd" },
  { name: "LIC Mutual Fund Asset Management Limited" },
  { name: "Mahindra Manulife Investment Management Pvt. Ltd." },
  { name: "Mirae Asset Investment Managers (India) Private Limited" },
  {
    name: "Motilal Oswal Asset Management Company Limited - Portfolio Managers",
  },
  { name: "Navi AMC Limited" },
  { name: "Nippon Life India Asset Management Ltd" },
  { name: "NJ Asset Management Private Limited" },
  { name: "Old Bridge Asset Management Private Limited" },
  { name: "PGIM India Asset Management Private Limited" },
  { name: "PPFAS Asset Management Pvt. Ltd" },
  { name: "Quant Money Managers Limited" },
  { name: "Quantum Asset Management Co Pvt. Ltd." },
  { name: "Samco Asset Management Pvt Ltd" },
  { name: "SBI Funds Management Ltd" },
  { name: "Shriram Asset Management Co Ltd" },
  { name: "Sundaram Asset Management Company Ltd" },
  { name: "Tata Asset Management Limited" },
  { name: "Taurus Asset Management Company Limited" },
  { name: "Trust Asset Management Private Limited" },
  { name: "Unifi Asset Management Private Limited" },
  { name: "Union Asset Management Co. Pvt. Ltd." },
  { name: "UTI Asset Management Co Ltd" },
  { name: "WhiteOak Capital Asset Management Limited" },
  { name: "Zerodha Asset Management Private Limited" },
];

export const FUND_TYPE_FILTERS: Record<string, string[]> = {
  Equity: [
    "Equity$Dividend Yield",
    "Equity$ELSS",
    "Equity$Flexi Cap",
    "Equity$Index Fund/ ETF",
    "Equity$Large & Mid Cap",
    "Equity$Large Cap",
    "Equity$Mid Cap",
    "Equity$Multi Cap",
    "Equity$Others",
    "Equity$Sectoral/ Thematic",
    "Equity$Small Cap",
    "Equity$Value Oriented",
  ],
  Hybrid: [
    "Hybrid$Aggressive Hybrid",
    "Hybrid$Arbitrage",
    "Hybrid$Balanced Hybrid",
    "Hybrid$Children's Fund",
    "Hybrid$Conservative Hybrid",
    "Hybrid$Dynamic Asset Allocation",
    "Hybrid$Equity Savings",
    "Hybrid$Multi Asset Allocation",
    "Hybrid$Others",
    "Hybrid$Retirement",
  ],
  Commodities: ["Commodities$Gold"],
  Debt: [
    "Debt$Banking & PSU",
    "Debt$Corporate Bond",
    "Debt$Credit Risk",
    "Debt$Dynamic Bond",
    "Debt$Floater",
    "Debt$Gilt",
    "Debt$Gilt – 10 year maturity",
    "Debt$Index Fund/ ETF",
    "Debt$Liquid",
    "Debt$Long Duration",
    "Debt$Low Duration",
    "Debt$Medium Duration",
    "Debt$Medium to Long Duration",
    "Debt$Money Market",
    "Debt$Others",
    "Debt$Overnight",
    "Debt$Sectoral/ Thematic",
    "Debt$Ultra Short Duration",
  ],
};

export const FUND_CATEGORY_INTERNAL_VALUES_MAP: Record<string, string[]> = {
  "Debt$Gilt – 10 year maturity": ["INCA000008"],
  "Hybrid$Aggressive Hybrid": ["INCA000043"],
  Hybrid$Arbitrage: ["INCA000038"],
  "Hybrid$Balanced Hybrid": ["INCA000012"],
  "Debt$Banking & PSU": ["INCA000065"],
  "Hybrid$Children's Fund": ["INCA000070"],
  "Hybrid$Conservative Hybrid": ["INCA000013"],
  "Equity$Value Oriented": ["INCA000057", "INCA000056"],
  "Debt$Corporate Bond": ["INCA000064"],
  "Debt$Credit Risk": ["INCA000050"],
  "Equity$Dividend Yield": ["INCA000058"],
  "Hybrid$Dynamic Asset Allocation": ["INCA000044"],
  "Debt$Dynamic Bond": ["INCA000053"],
  Equity$ELSS: ["INCA000033"],
  "Equity$Sectoral/ Thematic": [
    "INCA000072",
    "INCA000076",
    "INCA000051",
    "INCA000029",
    "INCA000030",
    "INCA000028",
    "INCA000003",
    "INCA000004",
    "INCA000006",
  ],
  "Equity$Index Fund/ ETF": ["INCA000060"],
  Commodities$Gold: ["INCA000032"],
  "Equity$Flexi Cap": ["INCA000031", "INCA000077", "INCA000059"],
  Equity$Savings: ["INCA000068"],
  Debt$Floater: ["INCA000066"],
  Debt$Others: ["INCA000071", "INCA000037", "INCA000046"],
  Debt$Gilt: ["INCA000009"],
  "Debt$Index Fund/ ETF": ["INCA000078"],
  "Equity$Large Cap": ["INCA000001"],
  "Equity$Large & Mid Cap": ["INCA000055"],
  Debt$Liquid: ["INCA000011"],
  "Debt$Long Duration": ["INCA000042"],
  "Debt$Low Duration": ["INCA000061"],
  "Debt$Medium Duration": ["INCA000063"],
  "Debt$Medium to Long Duration": ["INCA000034"],
  "Equity$Multi Cap": ["INCA000048"],
  "Debt$Money Market": ["INCA000062"],
  "Hybrid$Multi Asset Allocation": ["INCA000052"],
  Debt$Overnight: ["INCA000067"],
  Hybrid$Retirement: ["INCA000069"],
  "Equity$Small Cap": ["INCA000054"],
  "Debt$Ultra Short Duration": ["INCA000007"],
  "Equity$Mid Cap": ["INCA000002"],
};

/**
 * @deprecated use CUSTOM_AMC_LABELS_BY_AMC_ID instead
 */
export const AMC_LABELS = {
  "360 ONE Asset Management Limited": "360 ONE Mutual Fund",
  "Aditya Birla Sun Life AMC Ltd": "Aditya Birla Sun Life Mutual Fund",
  "Angel One Asset Management Company Limited": "Angel One Mutual Fund",
  "Axis Asset Management Company Limited": "Axis Mutual Fund",
  "Bajaj Finserv Asset Management Limited": "Bajaj Finserv Mutual Fund",
  "Bandhan Asset Management Company Limited": "Bandhan Mutual Fund",
  "Bank of India Investment Managers Private Limited":
    "Bank of India Mutual Fund",
  "Baroda BNP Paribas Asset Management India Pvt. Ltd.":
    "Baroda BNP Paribas Mutual Fund",
  "Canara Robeco Asset Management Co Ltd": "Canara Robeco Mutual Fund",
  "Capitalmind Asset Management Private Ltd": "Capitalmind Mutual Fund",
  "DSP Asset Managers Private Limited": "DSP Mutual Fund",
  "Edelweiss Asset Management Limited": "Edelweiss Mutual Fund",
  "Franklin Templeton Asst Mgmt(IND)Pvt Ltd": "Franklink Templeton Mutual Fund",
  "Groww Asset Management Ltd.": "Groww Mutual Fund",
  "HDFC Asset Management Co Ltd": "HDFC Mutual Fund",
  "Helios Capital Asset Management (India) Private Limited":
    "Helios Mutual Fund",
  "HSBC Asset Management (India) Private Ltd": "HSBC Mutual Fund",
  "ICICI Prudential Asset Management Company Limited":
    "ICICI Prudential Mutual Fund",
  "Invesco Asset Management (India) Private Ltd": "Invesco Mutual Fund",
  "ITI Asset Management Limited": "ITI Mutual Fund",
  "JM Financial Asset Management Limited": "JM Financial Mutual Fund",
  "Kotak Mahindra Asset Management Co Ltd": "Kotak Mahindra Mutual Fund",
  "LIC Mutual Fund Asset Management Limited": "LIC Mutual Fund",
  "Mahindra Manulife Investment Management Pvt. Ltd.":
    "Mahindra Manulife Mutual Fund",
  "Mirae Asset Investment Managers (India) Private Limited":
    "Mirae Asset Mutual Fund",
  "Motilal Oswal Asset Management Company Limited - Portfolio Managers":
    "Motilal Oswal Mutual Fund",
  "Navi AMC Limited": "Navi Mutual Fund",
  "Nippon Life India Asset Management Ltd": "Nippon India Mutual Fund",
  "NJ Asset Management Private Limited": "NJ Mutual Fund",
  "Old Bridge Asset Management Private Limited": "Old Bridge Mutual Fund",
  "PGIM India Asset Management Private Limited": "PGIM India Mutual Fund",
  "PPFAS Asset Management Pvt. Ltd": "PPFAS Mutual Fund",
  "Quant Money Managers Limited": "Quant Mutual Fund",
  "Quantum Asset Management Co Pvt. Ltd.": "Quantum Mutual Fund",
  "Samco Asset Management Pvt Ltd": "Samco Mutual Fund",
  "SBI Funds Management Ltd": "SBI Mutual Fund",
  "Shriram Asset Management Co Ltd": "Shriram Mutual Fund",
  "Tata Asset Management Pvt Ltd": "Tata Mutual Fund",
  "Taurus Asset Management Company Limited": "Taurus Mutual Fund",
  "Trust Asset Management Private Limited": "TRUST Mutual Fund",
  "Unifi Asset Management Private Limited": "Unifi Mutual Fund",
  "Union Asset Management Co. Pvt. Ltd.": "Union Mutual Fund",
  "UTI Asset Management Co Ltd": "UTI Mutual Fund",
  "WhiteOak Capital Asset Management Limited": "WhiteOak Mutual Fund",
};

export const CUSTOM_AMC_LABELS_BY_AMC_ID: Record<string, string> = {
  "0C000093WB": "360 ONE Mutual Fund",
  "0C0000O1YJ": "Abakkus Mutual Fund",
  "0C0000349B": "Aditya Birla Sun Life Mutual Fund",
  "0C0000OTFB": "Altiva SIF by Edelweiss Mutual Fund",
  "0C0000FDU3": "Angel One Mutual Fund",
  "0C000049GD": "Axis Mutual Fund",
  "0C0000CXA6": "Bajaj Finserv Mutual Fund",
  "0C0000CU70": "Bandhan Mutual Fund",
  "0C0000953A": "Baroda BNP Paribas Mutual Fund",
  "0C0000953B": "Canara Robeco Mutual Fund",
  "0C0000LIZF": "Capitalmind Mutual Fund",
  "0C0000CX2H": "DSP Mutual Fund",
  "0C00009532": "Edelweiss Mutual Fund",
  "0C00008JQU": "Franklink Templeton Mutual Fund",
  "0C000095E4": "Groww Mutual Fund",
  "0C00009534": "HDFC Mutual Fund",
  "0C0000D5FJ": "Helios Mutual Fund",
  "0C000049H6": "HSBC Mutual Fund",
  "0C0000953D": "ICICI Prudential Mutual Fund",
  "0C00008KJ3": "Invesco Mutual Fund",
  "0C0000BMDA": "ITI Mutual Fund",
  "0C00003GXW": "JM Financial Mutual Fund",
  "0C00001P1X": "Kotak Mahindra Mutual Fund",
  "0C00009535": "LIC Mutual Fund",
  "0C0000B4QH": "Mahindra Manulife Mutual Fund",
  "0C0000BRKM": "Mirae Asset Mutual Fund",
  "0C0000563U": "Motilal Oswal Mutual Fund",
  "0C00004HKO": "Navi Mutual Fund",
  "0C00001QYY": "Nippon Life Mutual Fund",
  "0C0000DDUY": "Old Bridge Mutual Fund",
  "0C00006EOL": "PGIM India Mutual Fund",
  "0C0000A4JB": "PPFAS Mutual Fund",
  "0C00009533": "Quant Mutual Fund",
  "0C00009537": "Quantum Mutual Fund",
  "0C0000CC2C": "Samco Mutual Fund",
  "0C00003HJY": "SBI Mutual Fund",
  "0C00008JNV": "Sundaram Mutual Fund",
  "0C00001W9X": "Tata Mutual Fund",
  "0C00009539": "Taurus Mutual Fund",
  "0C0000FEC3": "Unifi Mutual Fund",
  "0C00008U2Z": "Union Mutual Fund",
  "0C0000AJYO": "UTI Mutual Fund",
  "0C0000BJYY": "WhiteOak Capital Mutual Fund",
  "0C0000LM3H": "Wealth Company Mutual Fund",
};

export const FUND_METRICS_GLOSSARY: Record<string, string> = {
  manager_tenure:
    "Longer tenure (7+ years) indicates stability and experience with the fund's strategy.",
  ter: "The core recurring costs to run the fund. Lower BER improves returns.",
  rolling_return_3yr:
    "Annualized return over numerous 3-year windows, indicating consistency of returns.",
  rolling_return_5yr:
    "Annualized return over numerous 5-year windows, indicating consistency of returns.",
  relative_return_3yr:
    "Fund's excess return compared to its benchmark over 3-year period",
  relative_return_3yr_nse:
    "Fund's excess return compared to its benchmark over 3-year period",
  relative_return_5yr:
    "Fund's excess return compared to its benchmark over 5-year period",
  relative_return_5yr_nse:
    "Fund's excess return compared to its benchmark over 5-year period",
  sharpe_ratio_3yr:
    "Return generated per unit of risk—higher ratio means better risk-return profile.",
  standard_deviation_3yr:
    "Volatility of fund returns over 3 years—lower the better.",
  capture_ratio_downside_3yr:
    "Fund's participation in down-markets. Ratio <100 indicates the fund falls by less than the benchmark.",
  capture_ratio_upside_3yr:
    "Fund’s participation in up-markets. Ratio >100 indicates fund increases by more than the benchmark.",
  credit_qual_a_pct: "",
  credit_qual_bbb_pct: "",
  sortino_ratio_3yr:
    "Return generated per unit of downside risk-penalizes only harmful volatility, not upside swings. Higher is better.",
  modified_duration:
    "Sensitivity of the NAV to interest rate changes. Higher duration means NAV falls more than the rise in interest rates and vice-versa.",
  avg_credit_quality:
    "Average credit rating of the bonds held by the fund. Higher ratings (AAA) indicate lower default risk.",
};

export const FUND_METRIC_FORMATTER: Record<string, (val: string) => string> = {
  manager_tenure: (val: string) => `${Math.ceil(parseFloat(val))} yr(s)`,
  ter: (val: string) => formatAsPercentage(val, "-", 2),
  turnover_ratio: (val: string) => `${Number(val).toFixed(1)}`,
  rolling_return_3yr: (val: string) => formatAsPercentage(val, "-", 1),
  rolling_return_5yr: (val: string) => formatAsPercentage(val, "-", 1),
  relative_return_3yr: (val: string) => formatAsPercentage(val, "-", 1),
  relative_return_3yr_nse: (val: string) => formatAsPercentage(val, "-", 1),
  relative_return_5yr: (val: string) => formatAsPercentage(val, "-", 1),
  relative_return_5yr_nse: (val: string) => formatAsPercentage(val, "-", 1),
  sharpe_ratio_3yr: (val: string) => `${Number(val).toFixed(2)}`,
  sortino_ratio_3yr: (val: string) => `${Number(val).toFixed(2)}`,
  standard_deviation_3yr: (val: string) => `${Number(val).toFixed(1)}`,
  capture_ratio_downside_3yr: (val: string) => `${Number(val).toFixed(1)}`,
  capture_ratio_upside_3yr: (val: string) => `${Number(val).toFixed(1)}`,
  avg_credit_quality: (val: string) => val,
  modified_duration: (val: string) => `${Number(val).toFixed(2)}`,
  credit_qual_a_pct: (val: string) => val,
  credit_qual_bbb_pct: (val: string) => val,
};

export const FUND_BASKET_STRATEGY_OPTIONS = [
  { label: "Conservative", value: "conservative" },
  { label: "Moderate", value: "moderate" },
  { label: "Aggressive", value: "aggressive" },
] as const;

export const FUND_BASKET_TENURE_OPTIONS = [
  { label: "1 to 3 years", value: "1_to_3_years" },
  { label: "3 to 5 years", value: "3_to_5_years" },
  { label: "5+ years", value: "5_plus_years" },
] as const;

export const FUND_BASKET_TYPE_OPTIONS = [
  { label: "Curated", value: "curated" },
  { label: "Custom", value: "custom" },
] as const;

export const getRankingMetricLabel = (metric: string) =>
  ({
    capture_ratio_downside_3yr: "Capture ratio downside",
    capture_ratio_upside_3yr: "Capture ratio upside",
    relative_return_3yr: "Relative return 3Y",
    relative_return_3yr_nse: "Relative return 3Y",
    relative_return_5yr: "Relative return 5Y",
    relative_return_5yr_nse: "Relative return 5Y",
    rolling_return_3yr: "Rolling return 3Y",
    rolling_return_5yr: "Rolling return 5Y",
    ter: "Base expense ratio",
    manager_tenure: "Manager tenure",
    standard_deviation_3yr: "Standard deviation",
    sharpe_ratio_3yr: "Sharpe ratio",
    sortino_ratio_3yr: "Sortino ratio",
    avg_credit_quality: "Avg credit quality",
    credit_qual_a_pct: "Credit qual A %",
    credit_qual_bbb_pct: "Credit qual BBB %",
    modified_duration: "Modified duration",
  })[metric];

const pctChangeFrom = (value: number, base?: number | null) =>
  base ? ((value - base) * 100) / base : 0;

export function enhanceHistoricalNavWithPctChange(
  historicalNavs: HistoricalNav[] = []
) {
  const base = historicalNavs[0];

  return historicalNavs.map((h) => ({
    ...h,
    pct_change: pctChangeFrom(h.nav, base?.nav),
    pct_change_original: pctChangeFrom(
      h.nav_original_currency,
      base?.nav_original_currency
    ),
  }));
}

export function enhanceHistoricalNavWithPriceMovement(
  historicalNavs: HistoricalNav[] = [],
  base: number = 100
) {
  return enhanceHistoricalNavWithPctChange(historicalNavs).map((h) => ({
    ...h,
    price: base * (1 + h.pct_change / 100),
    price_original: base * (1 + h.pct_change_original / 100),
    benchmark_price:
      h.benchmark_pct_change != null
        ? base * (1 + h.benchmark_pct_change / 100)
        : null,
  }));
}
